import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CardLoading from '../../Components/CardLoading/CardLoading'
import Message from '../../Components/Message'
import './Project.scss'
import ProjectDetails from './ProjectDetails/ProjectDetails'
const Project = () => {

    const { projectId } = useParams()
    const [isLoading, setIsLoading]= useState(true)
    const [projects, setProjects] = useState([]) 
    const [error, setError] = useState('')
    useEffect(() => {
      setIsLoading(true)
      fetch("/projects.json")
        .then((res) => res.json())
        .then((data) => setProjects(data))
          .catch((err) => setError(err));
        setIsLoading(false);
    }, [projectId]);  

    const projectDetails = projects?.find((item) => item._id === projectId)
    console.log(projectDetails);
    let content = null;
    if (isLoading) {
        content = <CardLoading />
    } else if (!isLoading && error) {
        content = <Message message="That Was Server Error" color="gray" deep="100" />
    } else if (!isLoading && !error && !projectDetails?.name) {
        content = <Message message="Product Not Found!" color="red" />;
    } else if (!isLoading && !error && projectDetails) {
     content=( <>
            <ProjectDetails projectDetails=     {projectDetails} isLoading={isLoading} />
        </>
        )
    }

  return (
    <div className="project min-h-screen py-20">
      <h1 className="text-center font-extrabold text-5xl pb-10 text-emerald-50 ease-in duration-300 hover:text-emerald-400">
        Project Details
      </h1>
      <div className="lg:container mx-auto  px-4 ">{content}</div>
    </div>
  );
}

export default Project